<template>
  <div class="header flex">
    <div class="header_tab">
      <div
        v-if="mobile"
        :class="['nav_btn_box', nav_status ? 'click' : false]"
        @click="navOpen"
      >
        <div class="nav_btn"></div>
      </div>
    </div>
    <div class="admin_btn">
      <button class="btn_primary" @click="Logout">Log out</button>
    </div>
  </div>
</template>
<style lang="scss">
.header {
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  border-bottom: 1px solid #ccc;
  position: relative;
  z-index: 99;
  .header_tab {
    margin: 0 0px;
    font-size: 20px;
    > div {
      cursor: pointer;
      margin: 0 10px;
      &:hover {
        i {
          color: var(--mainColor);
        }
      }
    }
  .nav_btn_box {
    width: 50px;
    height: 50px;
    padding: 10px;
    cursor: pointer;
    &.click {
      .nav_btn {
        top: 10px;
        transition: 0.3s;
        transform: rotate(45deg);
        &::before {
          transition: 0.3s;
          content: "";
          transform: rotate(90deg);
          display: block;
          top: 0;
        }
        &::after {
          content: "";
          display: none;
        }
      }
    }
    .nav_btn {
      transition: 0.3s;
      background: var(--mainColor);
      width: 100%;
      height: 3px;
      position: relative;
      &::before {
        transition: 0.3s;
        content: "";
        display: block;
        background: var(--mainColor);
        width: 100%;
        height: 3px;
        position: absolute;
        top: 10px;
      }
      &::after {
        content: "";
        display: block;
        background: var(--mainColor);
        width: 100%;
        height: 3px;
        position: absolute;
        top: 20px;
      }
    }
    &:active {
      background: lighten(#682dff, 30%);
      border-radius: 5px;
    }
  }
  }
}
</style>
<script>
export default {
  name: "Header_block",
  data() {
    return {};
  },
  props: {
    mobile: Boolean,
    nav_status:Boolean,
  },
  methods: {
    Logout() {
      this.$store.commit("removeToken");
      this.$router.push({
        name: "landingpage",
      });
    },
    navOpen() {
      this.$emit("update:nav_status", !this.nav_status);
    },
  },
};
</script>